import { Icon } from '@material-ui/core';
import MyCollapse from 'components/Collapse';
import React from 'react';
import ShareableLinks from 'scenes/Producer/Product/MyProducts/components/ShareableLinks';

import styles from './styles';

import type IProduct from 'interfaces/IProduct';
import type IUser from 'interfaces/IUser';

interface IProps {
  copiedCheckout?: () => void;
  product: IProduct;
  currentUser?: IUser;
  classes?: any;
}
const QuickViewLinks = ({ product, copiedCheckout, classes }: IProps) => {
  return (
    <React.Fragment>
      <MyCollapse className={classes.collapse} title='Links' icon={<Icon style={{ fontSize: 16 }}>link</Icon>} arrow contentActive>
        <ShareableLinks copiedCheckout={copiedCheckout} productId={product.hash ?? product.id} />
      </MyCollapse>
    </React.Fragment>
  );
};

export default styles(QuickViewLinks) as any;
